<template>
  <div :class="show_second ? 'input-group' : ''">
    <select
      v-model="selection"
      class="form-select prevent-submit-onchange"
      :class="{
        'is-invalid': is_invalid,
        'flex-grow-0': show_second && size_1,
      }"
      :disabled="disabled"
      :style="{
        width: show_second ? size_1 : null,
      }"
      :title="label"
    >
      <option v-if="is_invalid" :value="selection">{{ value }}</option>
      <template v-for="(inner, label) in options" :key="label">
        <optgroup v-if="label" :label="label">
          <option
            v-for="(_, opt) in inner"
            :key="make_key(label, opt)"
            :value="make_key(label, opt)"
          >
            {{ opt }}
          </option>
        </optgroup>
        <template v-else>
          <option
            v-for="(_, opt) in inner"
            :key="make_key(label, opt)"
            :value="make_key(label, opt)"
          >
            {{ opt }}
          </option>
        </template>
      </template>
    </select>
    <input ref="hidden" v-model="current" :name="name" type="hidden" />
    <select
      v-if="show_second"
      ref="second"
      v-model="current"
      class="form-select prevent-submit-onchange"
      :class="{
        'flex-grow-0': size_2,
      }"
      :disabled="disabled || length(options_visible) <= 1"
      :style="{
        width: size_2,
      }"
      :title="placeholder"
    >
      <optgroup :label="label">
        <option v-for="(title, id) in options_visible" :key="id" :value="id">
          {{ title }}
        </option>
      </optgroup>
    </select>

    <slot name="buttons"></slot>
  </div>
</template>
<script>
import { apply, contains, first, last, length } from "@pdfking/rfunc"
import { Keys } from "@pdfking/tfunc"
import fire_event from "@pdfking/workflow/utils/fire_event"
import uuid from "@pdfking/workflow/utils/uuid"
const divider = "///"

export default {
  computed: {
    is_invalid() {
      return length(this.options_visible) == 0
    },
    label() {
      return last(this.selection.split(divider))
    },
    options_visible() {
      return this.options_for_selection(this.selection)
    },
    placeholder() {
      return this.options_visible[this.current]
    },

    selection: {
      get() {
        return this.find_value(this.current)
      },
      set(value) {
        this.current = first(Keys(this.options_for_selection(value)))
      },
    },
    show_second() {
      return length(this.options_visible) >= 1 && first(this.options_visible)
    },
  },
  data() {
    return {
      current: this.value,
      uuid: uuid(),
    }
  },
  emits: ["selection"],

  methods: {
    find_value(v) {
      for (const l in this.options) {
        for (const g in this.options[l]) {
          if (contains(this.options[l][g], v)) {
            return this.make_key(l, g)
          }
        }
      }
      return this.make_key("", "")
    },
    first,

    length,
    make_key: (label, selection) => label + divider + selection,

    options_for_selection(selection) {
      return apply(
        (l, g) => (this.options[l] ? this.options[l][g] : {}),
        selection.split(divider)
      )
    },
  },

  props: ["name", "value", "options", "size_1", "size_2", "disabled"],
  watch: {
    current() {
      this.$refs.hidden.value = this.current
      fire_event(this.$refs.hidden, "change")
      this.$emit("selection", this.current)
    },
  },
}
</script>
